const buttons = document.querySelectorAll(".jg-toggle-programm");

buttons.forEach(button => {
  button.addEventListener("click", (e) => {
    const programmList = button.closest('.programm__list');
    
    const blocks = programmList.querySelector('.programm__list__blocks');
    
    blocks.classList.toggle("active");
    button.classList.toggle("active");
  });
});

$(".programm__list__banner__close").on("click", function () {
  $(this).closest(".programm__list__banner").slideUp();
});

const swiperSliderHome = new Swiper(".slider__home", {
  loop: true,
  spaceBetween: 1,
  slidesPerView: "auto",
  speed: 800,
  pagination: {
    el: ".slider__home-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".slider__home-next",
    prevEl: ".slider__home-prev",
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
});
